import { Checkbox, Dropdown, TextField } from "@fluentui/react";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { EditPictureModel, FileCategory, FileType } from "../models/PictureModel";
import { PictureUtils } from "./PictureUtilities";

type PictureInputProps = {
    picture: EditPictureModel;
    index: number;
    onValueChange: <K extends keyof EditPictureModel>(
        id: number, field: K, value: EditPictureModel[K]) => void;
}

export default function PictureInputView({ picture, index, onValueChange }: PictureInputProps) {
    const column = Utils.getColumnWidth(2);

    const categoryPicker = () => {
        return <>
            <Dropdown
                label=""
                selectedKey={picture.category}
                options={DataUtils.getFileCategoryOptions()}
                onChange={(_, v) => onValueChange(
                    picture.id, "category",
                    v ? v.key as FileCategory : FileCategory.normal)
                }
            />
        </>;
    }

    const typePicker = () => {
        return <>
            <Dropdown
                label=""
                selectedKey={picture.type}
                options={DataUtils.getFileTypeOptions()}
                onChange={(_, v) =>
                    onValueChange(picture.id,
                        "type",
                        v ? v.key as FileType : FileType.image)
                }
            />
        </>;
    }

    const orderInput = () => {
        return <>
            <TextField
                label=""
                value={picture.order.toString()}
                onChange={(_, v) => onValueChange(picture.id, "order", Number(v) || 1)}
            />
        </>;
    }

    const collageOrderInput = () => {
        return <>
            <TextField
                label=""
                value={picture.collageOrder.toString()}
                onChange={(_, v) => onValueChange(picture.id, "collageOrder", Number(v) || 99)}
            />
        </>;
    }

    const isPrimaryCheckbox = () => {
        return <>
            <Checkbox
                label=""
                checked={picture.isPrimary}
                onChange={(_, v) => onValueChange(picture.id, "isPrimary", v || false)}
            />
        </>;
    }

    return <div className="ms-Grid-row pv-10">
        <div className={column}>
            {PictureUtils.getMiniPicture(picture.type, picture.imageUrl, "", () => { }, 90)}
        </div>
        <div className={column}>{categoryPicker()}</div>
        <div className={column}>{typePicker()}</div>
        <div className={column}>{orderInput()}</div>
        <div className={column}>{collageOrderInput()}</div>
        <div className={column + " pt-5"}>{isPrimaryCheckbox()}</div>
    </div>;
}